import util from '../util'

const controller = 'Enum'
export default Object.assign({}, util.GetCrud(controller, ['getall']))
